export default "__VITE_ASSET__BOa$x_1Y__"